module.exports = __webpack_public_path__ + "img/apple.b77e68bc.svg";